import React, { Component } from "react";
import { Row, Col, Card, Button, Form, Spinner, Container } from "react-bootstrap";
import BreadcrumbHeading from "../../breadcrumbs/BreadcrumbHeading";

import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { entryBranchDefault, scopeBranches } from "../../../../utils/branchScope";
import { getAuthorizedClassIds, filterByAuthorizedIds } from "../../../utils/authHelper";
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../../utils/moduleGuard";

// /settings/branch-classes is granted by the "branches" module (see MODULE_ROUTES in
// moduleAccessGuard — branches and branch-classes share the key).
// module_key ONLY, never module_name: "Settings" is the shared sidebar group, and
// can() grants an action when ANY matched row allows it, so matching the group name
// would let a sibling Settings module's grant leak in.
const BRANCHES_MODULE = ["branches"];
// module_key "branches" has two rows split by sub_module_name: "branches" (Branches page)
// and "classes" (this page). Scope every check to "classes" so this page reads ONLY its
// own row and the Branches-row grants can't leak in.
const BRANCHES_SUB = "classes";

const FETCH_BRANCHES = gql`
  query($institution_id: Int!) {
    getBranchesList(institution_id: $institution_id) {
      id
      branch_name
    }
  }
`;

const FETCH_CLASSES = gql`
  query {
    getClassesList {
      id
      class
      have_stream
      order_no
    }
  }
`;

const FETCH_BRANCH_CLASSES = gql`
  query($institute_id: Int!, $branch_id: Int!) {
    getBranchClasses(institute_id: $institute_id, branch_id: $branch_id) {
      id
    }
  }
`;

const ASSIGN_BRANCH_CLASSES = gql`
  mutation(
    $institute_id: Int!
    $branch_id: Int!
    $class_ids: [Int]
    $username: String
  ) {
    assignBranchClasses(
      institute_id: $institute_id
      branch_id: $branch_id
      class_ids: $class_ids
      username: $username
    )
  }
`;

// Header-card design — matches BranchesSection so Classes looks the same.
const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  titleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  title: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  subtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  countChip: { background: "#f5f3ff", color: "#7c3aed", borderRadius: 20, padding: "4px 12px", fontWeight: 600, fontSize: 12, border: "1px solid #ddd6fe" },
  headerActions: { display: "flex", gap: 10, marginLeft: "auto", alignItems: "center", flexWrap: "wrap" },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  content: { padding: "20px 24px" },
};

const CLS = {
  sectionHead: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 18,
  },
  sectionTitle: {
    color: "#0f172a",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    margin: 0,
  },
  countChip: {
    background: "#f5f3ff",
    color: "#7c3aed",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 600,
    fontSize: 12,
    border: "1px solid #ddd6fe",
  },
  headActions: { display: "flex", gap: 16, marginLeft: "auto" },
  linkBtn: {
    background: "none",
    border: "none",
    color: "#7c3aed",
    fontWeight: 600,
    fontSize: 12.5,
    cursor: "pointer",
    padding: 0,
  },
  tile: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "100%",
    padding: "14px 16px",
    borderRadius: 12,
    border: active ? "1.5px solid #7c3aed" : "1.5px solid #e2e8f0",
    background: active ? "#f5f3ff" : "#fff",
    boxShadow: active ? "0 2px 10px rgba(124,58,237,0.12)" : "none",
    cursor: "pointer",
    transition: "all 0.15s ease",
    textAlign: "left",
  }),
  tick: (active) => ({
    width: 22,
    height: 22,
    flexShrink: 0,
    borderRadius: 6,
    border: active ? "none" : "1.5px solid #cbd5e1",
    background: active ? "#7c3aed" : "#fff",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
  }),
  tileLabel: { display: "block", fontWeight: 600, fontSize: 14, color: "#0f172a", lineHeight: 1.2 },
};

class BranchClassesSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbsData: { Title: "Branch Classes" },
      // DATA-ENTRY: assignBranchClasses writes this as branch_id, so the dropdown
      // stays on the page. It pre-selects the header's branch when the scope
      // resolves to exactly one.
      branchId: entryBranchDefault(""),
      selectedClassIds: [],
      loadingClasses: false,
      saving: false,
      message: "",
      messageType: "",
      accessDeniedShow: false,
    };

    this.guard = attachModuleGuard(this, BRANCHES_MODULE, BRANCHES_SUB);
  }

  componentDidMount() {
    // is_view === 0 → never fetch this branch's class assignments. Bailing out here
    // (and not just at render) keeps the module's data off the wire entirely.
    if (!this.guard.canView()) return;

    // When the branch is auto-selected (single-branch user), load its existing
    // class assignments so the checked state reflects the saved data.
    if (this.state.branchId) {
      this.handleBranchChange({ target: { value: this.state.branchId } });
    }
  }

  componentWillUnmount() {
    if (this.msgTimer) clearTimeout(this.msgTimer);
  }

  handleBranchChange = async (e) => {
    const branchId = e.target.value;
    if (this.msgTimer) clearTimeout(this.msgTimer);
    this.setState({ branchId, message: "", selectedClassIds: [] });

    if (!branchId) return;

    this.setState({ loadingClasses: true });
    try {
      const { data } = await this.props.client.query({
        query: FETCH_BRANCH_CLASSES,
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
          branch_id: parseInt(branchId),
        },
        fetchPolicy: "network-only",
      });
      const assigned = (data && data.getBranchClasses) || [];
      this.setState({
        selectedClassIds: assigned.map((c) => parseInt(c.id)),
        loadingClasses: false,
      });
    } catch (err) {
      this.setState({
        loadingClasses: false,
        message: "Failed to load classes for this branch.",
        messageType: "danger",
      });
    }
  };

  // The classes this user may see and assign, narrowed by the class_ids cookie.
  // An empty assignment leaves the full list available (existing behaviour).
  visibleClasses = () => {
    const all = (this.props.getClasses && this.props.getClasses.getClassesList) || [];
    return filterByAuthorizedIds(all, getAuthorizedClassIds(), "id");
  };

  visibleClassIds = () => this.visibleClasses().map((c) => parseInt(c.id));

  // Select-all / clear only ever touch the classes this user can SEE. The save sends
  // selectedClassIds as the branch's complete assignment, so a class that is assigned
  // but out of this user's scope must survive both actions untouched — otherwise a
  // restricted user would silently unassign classes they were never shown.
  selectAll = () => {
    const visible = this.visibleClassIds();
    this.setState((prev) => ({
      selectedClassIds: [
        ...prev.selectedClassIds.filter((id) => !visible.includes(id)),
        ...visible,
      ],
      message: "",
    }));
  };

  clearAll = () => {
    const visible = this.visibleClassIds();
    this.setState((prev) => ({
      selectedClassIds: prev.selectedClassIds.filter((id) => !visible.includes(id)),
      message: "",
    }));
  };

  toggleClass = (classId) => {
    const id = parseInt(classId);
    this.setState((prev) => {
      const exists = prev.selectedClassIds.includes(id);
      return {
        selectedClassIds: exists
          ? prev.selectedClassIds.filter((c) => c !== id)
          : [...prev.selectedClassIds, id],
        message: "",
      };
    });
  };

  handleSave = async () => {
    // Saving the assignment is a write → is_edit. Checked before the branch
    // validation so a role without the grant is told they lack access, rather than
    // being sent to fix a form they were never allowed to submit. This is also the
    // last gate before the mutation leaves the client.
    if (!this.guard.requireEdit()) return;

    const { branchId, selectedClassIds } = this.state;
    if (!branchId) {
      this.setState({
        message: "Please select a branch.",
        messageType: "danger",
      });
      return;
    }

    this.setState({ saving: true, message: "" });
    try {
      await this.props.assignBranchClasses({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
          branch_id: parseInt(branchId),
          class_ids: selectedClassIds,
          username: Cookies.get("username"),
        },
      });
      this.setState({
        saving: false,
        branchId: "",
        selectedClassIds: [],
        message: "Classes saved successfully.",
        messageType: "success",
      });
      this.msgTimer = setTimeout(() => {
        this.setState({ message: "", messageType: "" });
      }, 2500);
    } catch (err) {
      this.setState({
        saving: false,
        message: "Failed to save classes. Please try again.",
        messageType: "danger",
      });
    }
  };

  render() {
    // is_view === 0 → the module's data is never rendered. The page shell (navbar /
    // sidebar / footer) comes from BranchClasses.jsx, so the user can still navigate.
    if (!this.guard.canView()) {
      return (
        <div style={FIN.wrapper} className="branch_classes_section">
          <AccessDeniedCard />
        </div>
      );
    }

    const { getBranches } = this.props;
    // Narrowed to the header's (NavbarOne) branch scope, which itself never widens
    // past the branches the user is authorized for (the comma-separated branch_id
    // cookie). The dropdown stays because its value is SAVED as branch_id.
    const branches = scopeBranches((getBranches && getBranches.getBranchesList) || []);
    // Show only the classes this user is assigned (class_ids cookie); an empty
    // assignment leaves every class visible.
    const classes = this.visibleClasses();
    const {
      branchId,
      selectedClassIds,
      loadingClasses,
      saving,
      message,
      messageType,
    } = this.state;

    return (
      <div style={FIN.wrapper} className="branch_classes_section">
        <Container fluid className="px-0">
          <div style={FIN.card}>
            <div style={FIN.cardHeader}>
              <div style={FIN.iconWrapper}><i className="fal fa-chalkboard" /></div>
              <div style={FIN.titleText}>
                <h5 style={FIN.title}>Classes</h5>
                <span style={FIN.subtitle}>Assign classes to branches</span>
              </div>
              <div style={FIN.headerActions}>
                {branchId ? (
                  <span style={FIN.countChip}>
                    {/* Count only the classes on screen, so the chip matches the tiles. */}
                    {selectedClassIds.filter((id) =>
                      classes.some((c) => parseInt(c.id) === id)
                    ).length}{" "}
                    / {classes.length} selected
                  </span>
                ) : null}
              </div>
            </div>

            <div style={FIN.content}>
              <Form>
                <Form.Row>
                  <Form.Group as={Col} lg={5} md={6} sm={12} controlId="SelectBranch">
                    <Form.Label className="text-uppercase">Branch Name</Form.Label>
                    <Form.Control
                      as="select"
                      value={branchId}
                      onChange={this.handleBranchChange}
                    >
                      <option value="">Select Branch</option>
                      {branches.map((b) => (
                        <option key={b.id} value={b.id}>
                          {b.branch_name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>

                {branchId ? (
                  <div className="mt-4">
                    <div style={CLS.sectionHead}>
                      <p style={CLS.sectionTitle}>Classes available at this branch</p>
                      {!loadingClasses && classes.length > 0 ? (
                        <div style={CLS.headActions}>
                          <button type="button" style={CLS.linkBtn} onClick={this.selectAll}>
                            Select all
                          </button>
                          <button type="button" style={CLS.linkBtn} onClick={this.clearAll}>
                            Clear
                          </button>
                        </div>
                      ) : null}
                    </div>

                    {loadingClasses ? (
                      <div className="py-3 text-muted">
                        <Spinner animation="border" size="sm" /> Loading...
                      </div>
                    ) : classes.length === 0 ? (
                      <p className="text-muted">No classes found.</p>
                    ) : (
                      <Row>
                        {classes.map((c) => {
                          const active = selectedClassIds.includes(parseInt(c.id));
                          return (
                            <Col xl={3} lg={4} md={6} sm={12} key={c.id} className="mb-3">
                              <div
                                role="button"
                                tabIndex={0}
                                style={CLS.tile(active)}
                                onClick={() => this.toggleClass(c.id)}
                                onKeyPress={() => this.toggleClass(c.id)}
                              >
                                <span style={CLS.tick(active)}>{active ? "✓" : ""}</span>
                                <span style={CLS.tileLabel}>{c.class}</span>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                  </div>
                ) : (
                  <p className="text-muted mt-3">
                    Select a branch to assign classes.
                  </p>
                )}

                {message ? (
                  <div className={`alert alert-${messageType} mb-0 mt-3`}>{message}</div>
                ) : null}

                {branchId ? (
                  <div className="text-right mt-4">
                    <button
                      type="button"
                      style={{ ...FIN.btnPrimary, opacity: saving ? 0.7 : 1, cursor: saving ? "not-allowed" : "pointer" }}
                      onClick={this.handleSave}
                      disabled={saving}
                    >
                      {saving ? "Saving..." : "Save"}
                    </button>
                  </div>
                ) : null}
              </Form>
            </div>
          </div>
        </Container>

        {/* Shown instead of saving when is_edit is missing. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(FETCH_BRANCHES, {
        options: () => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
          fetchPolicy: "network-only",
        }),
        name: "getBranches",
      }),
      graphql(FETCH_CLASSES, {
        options: () => ({
          fetchPolicy: "network-only",
        }),
        name: "getClasses",
      }),
      graphql(ASSIGN_BRANCH_CLASSES, {
        name: "assignBranchClasses",
      })
    )(BranchClassesSection)
  )
);
